module.exports = __webpack_public_path__ + "img/t_earnings.cc188bca.svg";